import React from "react";
import { useTranslation } from "react-i18next";
import UIText from "./UIText";

const UIButton = ({
    type = "button",
    arrowRightYellow,
    arrowLeftWhite,
    arrowRightWhite,
    disabled,
    glassSecondary,
    primary,
    primaryGlass,
    primaryIcon,
    secondary,
    whatsapp,
    whatsappNumber,
    url,
    scrollToTop,
    className,
    children,
    action,
    ariaLabel = "botón",
}) => {
    const { t } = useTranslation();
    const content = children || t("FormButton");
    const textContent = (
        <UIText as="span" variant="button" weight="bold" className="inline-flex items-center justify-center text-inherit">
            {content}
        </UIText>
    );

    return (
        <button
            type={type}
            disabled={disabled}
            aria-label={ariaLabel}
            className={`
                outline-none
                inline-flex
                items-center
                justify-center
                group
                ${className}
                ${disabled && "bg-slate-500"}
                ${primary && "bg-yellow-500 rounded-full px-5 py-1 text-black"}
                ${glassSecondary && "rounded-[999px] bg-[linear-gradient(180deg,rgba(125,211,252,0.95)_0%,rgba(59,130,246,0.92)_48%,rgba(29,78,216,0.96)_100%)] p-[1px] text-white shadow-[0_14px_34px_rgba(37,99,235,0.35)] transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_22px_42px_rgba(34,211,238,0.28)]"}
                ${primaryGlass && "rounded-[999px] bg-[linear-gradient(90deg,#ccefff1a_0%,#13f2ff45_100%)] p-[1px] text-gray-100 no-underline shadow-[0_10px_30px_rgba(56,189,248,0.18)] transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_20px_45px_rgba(96,165,250,0.30)] hover:brightness-110"}
                ${primaryIcon && "border border-yellow-500 rounded-full px-12 py-2 xl:px-16 xl:py-6 text-yellow-500 bg-icon-eye bg-[length:10px_10px] xl:bg-[length:35px_35px] bg-contain-[15px] bg-[center_right_10px] xl:bg-[center_right_10px] bg-no-repeat"}
                ${secondary && "bg-trasparent rounded-full border border-yellow-500 px-5 py-1 text-yellow-500"}
                ${whatsapp && "fixed right-2 bottom-[22%] w-[40px] md:w-[50px] h-[40px] md:h-[50px] z-999 bg-icon-whatsapp bg-cover cursor-pointer"}
                ${arrowRightYellow && "w-6 h-6 bg-icon-arrow-right-yellow bg-contain bg-no-repeat"}
                ${arrowLeftWhite && "bg-icon-circle-left-white bg-contain bg-no-repeat"}
                ${arrowRightWhite && "bg-icon-circle-right-white bg-contain bg-no-repeat"}
            `}
            onClick={() => {
                if (scrollToTop) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                }

                if (action) {
                    action();
                } else if (whatsappNumber) {
                    window.open(`https://api.whatsapp.com/send?phone=${whatsappNumber}`, "_blank");
                } else if (url) {
                    window.open(url, "_blank");
                }
            }}
        >
            {primaryGlass ? (
                <span className="rounded-[999px] border border-white/15 bg-slate-950/35 px-7 py-3.5 text-white backdrop-blur-lg transition duration-300 group-hover:border-cyan-200/40 group-hover:bg-slate-950/50 md:px-8 md:py-4 xl:px-10">
                    {textContent}
                </span>
            ) : glassSecondary ? (
                <span className="rounded-[999px] border border-white/35 bg-[linear-gradient(180deg,rgba(255,255,255,0.30)_0%,rgba(191,219,254,0.18)_18%,rgba(30,64,175,0.14)_100%)] px-6 py-3 tracking-[0.01em] text-white backdrop-blur-md transition duration-300 group-hover:border-cyan-100/60 group-hover:bg-[linear-gradient(180deg,rgba(255,255,255,0.36)_0%,rgba(147,197,253,0.24)_22%,rgba(30,64,175,0.20)_100%)] md:px-7 md:py-3.5">
                    {textContent}
                </span>
            ) : (
                textContent
            )}
        </button>
    );
};

export default UIButton;
